/* eslint-disable import/prefer-default-export */
import ToyPCSdk from './ToyPCSdk.class.js'

export { ToyPCSdk }
